import { Editor } from 'roosterjs-editor-core';
import {
    ChangeSource,
    PluginEvent,
    PluginEventType,
    ContentChangedEvent,
} from 'roosterjs-editor-types';

export default function linkPreviewPluginTrigger(evt: PluginEvent, editor: Editor) {
    if (evt.eventType === PluginEventType.ContentChanged) {
        const contentChangedEvent: ContentChangedEvent = evt as ContentChangedEvent;
        if (
            (contentChangedEvent.source === ChangeSource.AutoLink ||
                contentChangedEvent.source === ChangeSource.SetContent) &&
            editor
                .getContent(false /*triggerExtractContentEvent*/)
                .toLowerCase()
                .indexOf('<a ') >= 0
        ) {
            return true;
        }
    }

    return false;
}
